const getRequiredEnv = (key: keyof ImportMetaEnv) => {
  const value = String(import.meta.env[key] ?? '');

  if (!value) {
    throw new Error(`Missing required environment variable: ${key}`);
  }

  return value;
};

export const env = {
  apiBaseUrl: getRequiredEnv('VITE_API_BASE_URL').replace(/\/$/, ''),
  billingEnabled: String(import.meta.env.VITE_BILLING_ENABLED ?? 'false') === 'true',
  stripePublishableKey: String(import.meta.env.VITE_STRIPE_PUBLISHABLE_KEY ?? '')
};

window.__FUELOPS_API_BASE_URL__ = env.apiBaseUrl;
